import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeliveryLocation } from '@/contexts/DeliveryLocationContext';

const EXCLUDED_ROUTES = [
  '/admin', 
  '/vendor', 
  '/auth', 
  '/forgot-password', 
  '/tips', 
  '/holiday',
  '/contact',
  '/shipping',
  '/returns',
  '/vendor/auth', 
  '/vendor-entry', 
  '/blog',
  '/tag',
  '/tags',
  '/sitemap.xml',
  '/sitemap',
  '/robots.txt',
  '/manifest.json',
  '/manifest-vendor.json',
  '/vendor-sw.js',
  '/offline.html'
];

export default function CityRedirector() {
  const { selectedCity } = useDeliveryLocation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    
    // Exclude admin, vendor, auth, forgot-password, and already city-prefixed
    if (EXCLUDED_ROUTES.some(route => path.startsWith(route))) return;
    if (path.startsWith('/en-eg/') || path.startsWith('/ar-eg/')) return;
    // Exclude legacy /en and /ar routes (with any suffix)
    if (path.startsWith('/en') || path.startsWith('/ar')) return;
    if (!selectedCity) return;
    
    // Redirect to city-prefixed version of current path
    navigate(`/en-eg/${selectedCity.slug}${path}${location.search}`, { replace: true });
  }, [selectedCity, location, navigate]);

  return null;
} 